import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatChipOption} from '@angular/material/chips';
import {Tag} from '../models';

@Component({
    selector: 'frog-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    imports: [MatChipOption],
})
export class TagComponent implements OnInit {
    @Input() tag: Tag;
    @Output() onClose = new EventEmitter<Tag>();
    @Output() onClick = new EventEmitter<Tag>();

    constructor() {}

    ngOnInit(): void {}

    clickHandler(event: MouseEvent) {
        event.preventDefault();
        this.onClick.emit(this.tag);
    }

    closeHandler(event: MouseEvent) {
        event.preventDefault();
        this.onClose.emit(this.tag);
    }
}
